module.exports = __webpack_public_path__ + "img/coffeeCup_brand_logo.4c891989.png";